var _filter, _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgS1PosterEle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 700,
    viewBox: "0 0 500 700",
    width: 500,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 172.727,
    width: 545.454,
    x: -22.7273,
    y: 550
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.45454
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.92549 0 0 0 0 0.494118 0 0 0 0 0.694118 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_2744_159229"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2744_159229",
    mode: "normal",
    result: "shape"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h500v700h-500z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fae9f2",
    height: 92.7272,
    rx: 37.2727,
    width: 465.454,
    x: 17.2727,
    y: 584.546
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ea0d8b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.6575 606.057c-3.6786.071-6.3172-2.298-6.3874-5.927-.0485-2.505.7324-5.373 3.1352-10.864l3.0415-7.06c.2408-.524.7358-.879 1.321-.89l4.0966-.08c.7525-.014 1.1806.496.9448 1.279l-3.6201 11.738c2.1921.908 3.6535 2.955 3.7037 5.547.0686 3.542-2.473 6.184-6.2353 6.257zm15.9686-.309c-3.6786.071-6.3172-2.298-6.3874-5.927-.0485-2.505.7323-5.373 3.1352-10.865l3.0415-7.059c.2408-.524.7357-.879 1.321-.89l4.0966-.08c.7524-.014 1.1805.496.9447 1.279l-3.6201 11.738c2.1922.908 3.6536 2.955 3.7037 5.547.0686 3.542-2.473 6.184-6.2352 6.257z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m471.737 662.849c3.679-.072 6.317 2.297 6.387 5.926.049 2.506-.732 5.373-3.135 10.865l-3.041 7.06c-.241.523-.736.879-1.321.89l-4.097.079c-.752.015-1.18-.496-.945-1.278l3.62-11.739c-2.192-.908-3.653-2.954-3.703-5.546-.069-3.542 2.473-6.185 6.235-6.257zm-15.969.309c3.679-.072 6.318 2.297 6.388 5.926.048 2.506-.733 5.373-3.135 10.865l-3.042 7.06c-.241.523-.736.879-1.321.89l-4.096.079c-.753.015-1.181-.496-.945-1.278l3.62-11.739c-2.192-.908-3.654-2.954-3.704-5.546-.068-3.542 2.473-6.185 6.235-6.257z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS1PosterEle);
export default __webpack_public_path__ + "static/media/S1_POSTER_ELE.a81a97473d4ac9e5dfd8d9205c645d7f.svg";
export { ForwardRef as ReactComponent };